<template>
  <div>
    <b-container fluid class="mb-4">
      <b-row>
        <b-col class="pl-0">
          <slot name="left-header"></slot>
          <div class="d-flex text-capitalize align-items-center">
            <span>show</span>
            <b-form-select :options="entriesOpt(customEntryOptions)" class="w-25 mx-2" v-model="perPageProps"
              v-if="dropdownSizeProps" :size="dropdownSizeProps"></b-form-select>
            <b-form-select :options="entriesOpt(customEntryOptions)" class="w-25 mx-2" v-model="perPageProps"
              v-else></b-form-select>
            <span>entries</span>
          </div>
        </b-col>
        <b-col class="pr-0">
          <div class="d-flex justify-content-end">
            <slot name="right-header"></slot>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <slot></slot>
    <div class="row five-entries">
      <div class="d-flex align-items-center justify-content-center col-md-12">
        <span class="pl-2">Display {{ fromPage }} to {{ toPage }} of
          {{ rows }} entries</span>
        <b-pagination class="mt-4 d-flex justify-content-center flex-grow-1"
          v-model="currentPageProps" :total-rows="rows" :limit="5" :per-page="perPage" style="margin-left: -10em"></b-pagination>
      </div>
    </div>
    <div class="row mt-2 three-entries">
      <div class="col-lg-4 col-md-4 col-sm-12 mt-3 pagination-text">
        <span>Display {{ fromPage }} to {{ toPage }} of {{ rows }}
          entries</span>
      </div>
      <div class="col-lg-8 col-md-8 col-sm-12 mt-2">
        <b-pagination class="justify-content-center" v-model="currentPageProps" :total-rows="rows" :limit="3" :per-page="perPage"></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    perPage: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    fromPage: {
      type: Number,
      required: true,
      default: 0
    },
    toPage: {
      type: Number,
      required: true,
      default: 0
    },
    rows: {
      type: Number,
      required: true
    },
    customEntryOptions: {
      type: Object,
      default: Object
    },
    customPagingClass: {
      type: Array
    },
    dropdownSizeProps: {
      type: String,
      default: () => null
    }
  },
  methods: {
    pageChanged({ perPage, currentPage }) {
      this.$emit("pageChanged", {
        perPage: perPage,
        currentPage: currentPage
      });
    }
  },
  computed: {
    perPageProps: {
      get() {
        return this.perPage;
      },
      set(val) {
        this.pageChanged({ perPage: val, currentPage: this.currentPage });
      }
    },
    currentPageProps: {
      get() {
        return this.currentPage;
      },
      set(val) {
        this.pageChanged({ currentPage: val, perPage: this.perPage });
      }
    }
  }
};
</script>

<style>
@media screen and (min-width: 768px) {
  .three-entries {
    display: none;
  }

  .five-entries {
    display: block;
  }

  .pagination-text {
    text-align: left !important;
  }
}

@media screen and (max-width: 767px) {
  .three-entries {
    display: block;
  }

  .five-entries {
    display: none;
  }

  .pagination-text {
    text-align: center !important;
  }

  .pagination-body {
    justify-content: center !important;
  }
}
</style>